import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'

class Iframe extends Component {
  shouldComponentUpdate() {
    return false
  }

  render() {
    return (
      <div
        className={`${midas.videoResponsive} ${midas.videoResponsive11}`}
        ref={p => {
          this.parent = p
        }}
      >
        <iframe
          title={Math.random()}
          src={
            this.props.local
              ? `/static/iframes/${this.props.frame}.html`
              : this.props.frame
          }
          id={this.props.frame}
          style={{
            border: 'none',
            overflow: 'hidden',
            height: '100%',
          }}
          frameBorder="0"
          ref={f => {
            this.iframe = f
          }}
          onLoad={() => {
            if (this.props.print) {
              setTimeout(() => this.iframe.contentWindow.print(), 100)
            }
            if (this.props.local) {
              // can only access inner properties from same origin frames
              setInterval(() => {
                if (this.parent) {
                  this.parent.setAttribute(
                    'style',
                    /* prettier-ignore */
                    // eslint-disable-next-line
                    `height: ${this.iframe.contentWindow.document.body.scrollHeight + 10}px`,
                  )
                }
              }, 1000)
            }
          }}
        />
      </div>
    )
  }
}

Iframe.propTypes = {
  frame: PropTypes.string.isRequired,
  local: PropTypes.bool,
  print: PropTypes.bool,
}

Iframe.defaultProps = {
  local: false,
  print: false,
}

export default Iframe
